import { render, staticRenderFns } from "./AdminStats.vue?vue&type=template&id=7b1d398a&scoped=true"
import script from "./AdminStats.vue?vue&type=script&lang=js"
export * from "./AdminStats.vue?vue&type=script&lang=js"
import style0 from "./AdminStats.vue?vue&type=style&index=0&id=7b1d398a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d398a",
  null
  
)

export default component.exports